export default "__VITE_ASSET__hFg_rsu3__"